import type { ArticleManagement } from '@libs/domain';
import { removeCommas } from '@ps-smart-cp/ppfw-client';

class ArticleSetting
  implements
    Pick<
      ArticleManagement['schema'],
      'articleNoBranchMin' | 'articleNoParentDigits' | 'isAutoNumbering' | 'isPaddingParentNoWithZero'
    >
{
  /**
   *
   * @param articleNoParentDigits 物件番号・親の桁数
   * @param isPaddingParentNoWithZero 物件番号・親のゼロ詰め
   * @param articleNoBranchMin 物件番号・枝の最小値
   * @param isAutoNumbering 自動採番機能
   */
  private constructor(
    readonly articleNoParentDigits: string,
    readonly isPaddingParentNoWithZero: boolean,
    readonly articleNoBranchMin: string,
    readonly isAutoNumbering: boolean,
  ) {}

  static init() {
    return new ArticleSetting('', false, '', false);
  }

  static fromRaw(raw: ArticleSettingRaw) {
    return new ArticleSetting(
      raw.articleNoParentDigits.toString(),
      raw.isPaddingParentNoWithZero,
      raw.articleNoBranchMin.toString().padStart(3, '0'),
      raw.isAutoNumbering,
    );
  }
}

export { ArticleSetting };

export class ArticleSettingRaw
  implements
    Pick<
      ArticleManagement['record'],
      'articleNoBranchMin' | 'articleNoParentDigits' | 'isAutoNumbering' | 'isPaddingParentNoWithZero'
    >
{
  private constructor(
    readonly articleNoParentDigits: number,
    readonly isPaddingParentNoWithZero: boolean,
    readonly articleNoBranchMin: number,
    readonly isAutoNumbering: boolean,
  ) {}

  static fromModel(articleManagement: ArticleSetting) {
    return new ArticleSettingRaw(
      Number.parseInt(removeCommas(articleManagement.articleNoParentDigits)),
      articleManagement.isPaddingParentNoWithZero,
      Number.parseInt(articleManagement.articleNoBranchMin),
      articleManagement.isAutoNumbering,
    );
  }
}
